
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class KatalogKonusuAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "Kutuphane/KatalogKonusu";
        super(baseUrl);
    }


    KatalogKonusu() {

        return this.get("");

    }

}
export default new KatalogKonusuAPI();
